import { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Truck } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { track } from '../analytics/track';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking');
  const [data, setData] = useState(null);
  const { clear } = useCart();
  const polled = useRef(false);

  useEffect(() => {
    if (!sessionId || polled.current) return;
    polled.current = true;
    let attempts = 0;
    const max = 8;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/checkout/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === 'paid') {
          setStatus('paid');
          track('purchase', { value: (r.data.amount_total || 0) / 100, currency: 'EUR' });
          clear();
          return;
        }
        if (r.data.status === 'expired') { setStatus('expired'); return; }
        if (attempts < max) { attempts++; setTimeout(poll, 2000); }
        else setStatus('timeout');
      } catch {
        setStatus('error');
      }
    };
    poll();
  }, [sessionId, clear]);

  return (
    <main data-testid="checkout-success-page" className="container-essenya py-24 text-center max-w-xl">
      {status === 'paid' && (
        <>
          <CheckCircle2 size={60} strokeWidth={1.2} className="mx-auto mb-6 text-essenya-ink" />
          <h1 className="font-display text-4xl md:text-5xl mb-4">Grazie per il tuo ordine</h1>
          <p className="text-essenya-text text-lg mb-8">Ti abbiamo inviato la conferma via email. Il tuo ordine è in preparazione.</p>
          <div className="bg-white rounded-xl border border-essenya-border p-6 text-left mb-8">
            <p className="text-sm text-essenya-text">Importo pagato</p>
            <p className="font-display text-3xl">{((data?.amount_total || 0) / 100).toFixed(2).replace('.', ',')}€</p>
          </div>
          <div className="flex gap-3 justify-center">
            <Link to="/tracking" className="btn-primary"><Truck size={16} strokeWidth={1.5} className="mr-2" />Traccia ordine</Link>
            <Link to="/shop" className="btn-secondary">Continua lo shopping</Link>
          </div>
        </>
      )}
      {status === 'checking' && (
        <>
          <div className="w-12 h-12 border-2 border-essenya-ink border-t-transparent rounded-full animate-spin mx-auto mb-6" />
          <h1 className="font-display text-3xl mb-2">Verifico il pagamento...</h1>
          <p className="text-essenya-text">Un attimo, stiamo confermando la transazione.</p>
        </>
      )}
      {(status === 'expired' || status === 'timeout' || status === 'error') && (
        <>
          <h1 className="font-display text-3xl mb-3">Qualcosa non ha funzionato</h1>
          <p className="text-essenya-text mb-6">Il pagamento non è stato confermato. Riprova o contattaci.</p>
          <Link to="/checkout" className="btn-primary">Riprova checkout</Link>
        </>
      )}
    </main>
  );
}
